import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import LoginModal from './LoginModal';
import { useAuth } from '../context/AuthContext';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.theme === 'dark' ||
    (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
  );
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();
  const userMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDarkMode);
    localStorage.theme = isDarkMode ? 'dark' : 'light';
  }, [isDarkMode]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) setIsUserMenuOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const openLoginModal = () => {
    setIsLoginModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLoginModal = () => {
    setIsLoginModalOpen(false);
    document.body.style.overflow = '';
  };

  const handleLogout = async () => {
    setIsUserMenuOpen(false);
    await logout();
    window.location.reload();
  };

  return (
    <>
      <header className="atlas-header">
        <nav className="atlas-header-inner" aria-label="Основная навигация">
          <Link to="/" className="atlas-brand">dmishanin.ru</Link>
          <div className="atlas-nav-links">
            <a href="/#about">О портале</a>
            <Link to="/projects">Проекты</Link>
            <Link to="/articles">Статьи</Link>
          </div>
          <div className="atlas-header-actions">
            <button type="button" className="atlas-theme-toggle" onClick={() => setIsDarkMode((value) => !value)} aria-label={isDarkMode ? 'Включить светлую тему' : 'Включить тёмную тему'}>
              {isDarkMode ? '☼' : '◐'}
            </button>
            <button type="button" className="atlas-menu-toggle" onClick={() => setIsMenuOpen((value) => !value)} aria-expanded={isMenuOpen} aria-label="Открыть меню">☰</button>
            {isAuthenticated ? (
              <div ref={userMenuRef} className="atlas-user-menu">
                <button type="button" className="atlas-user-button" onClick={() => setIsUserMenuOpen((value) => !value)}>{user?.first_name || 'Профиль'} <span aria-hidden="true">⌄</span></button>
                {isUserMenuOpen && <div className="atlas-user-dropdown"><button type="button" onClick={handleLogout}>Выйти</button></div>}
              </div>
            ) : (
              <button type="button" className="atlas-login-button" onClick={openLoginModal}>Войти</button>
            )}
          </div>
        </nav>
        {isMenuOpen && (
          <div className="atlas-mobile-menu">
            <a href="/#about" onClick={() => setIsMenuOpen(false)}>О портале</a>
            <Link to="/projects" onClick={() => setIsMenuOpen(false)}>Проекты</Link>
            <Link to="/articles" onClick={() => setIsMenuOpen(false)}>Статьи</Link>
            {!isAuthenticated && <button type="button" onClick={openLoginModal}>Войти</button>}
          </div>
        )}
      </header>
      <LoginModal isOpen={isLoginModalOpen} onClose={closeLoginModal} />
    </>
  );
};

export default Header;
